import createLucideIcon from '../createLucideIcon';

/**
 * @component @name FileCog
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMnY0YTIgMiAwIDAgMCAyIDJoNCIgLz4KICA8cGF0aCBkPSJtMi4zMDUgMTUuNTMuOTIzLS4zODIiIC8+CiAgPHBhdGggZD0ibTMuMjI4IDEyLjg1Mi0uOTI0LS4zODMiIC8+CiAgPHBhdGggZD0iTTQuNjc3IDIxLjVhMiAyIDAgMCAwIDEuMzEzLjVIMThhMiAyIDAgMCAwIDItMlY3bC01LTVINmEyIDIgMCAwIDAtMiAydjIuNSIgLz4KICA8cGF0aCBkPSJtNC44NTIgMTEuMjI4LS4zODMtLjkyMyIgLz4KICA8cGF0aCBkPSJtNC44NTIgMTYuNzcyLS4zODMuOTI0IiAvPgogIDxwYXRoIGQ9Im03LjE0OCAxMS4yMjguMzgzLS45MjMiIC8+CiAgPHBhdGggZD0ibTcuNTMgMTcuNjk2LS4zODItLjkyNCIgLz4KICA8cGF0aCBkPSJtOC43NzIgMTIuODUyLjkyMy0uMzgzIiAvPgogIDxwYXRoIGQ9Im04Ljc3MiAxNS4xNDguOTIzLjM4MyIgLz4KICA8Y2lyY2xlIGN4PSI2IiBjeT0iMTQiIHI9IjMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/file-cog
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const FileCog = createLucideIcon('file-cog', [
  ['path', { d: 'M14 2v4a2 2 0 0 0 2 2h4', key: 'tnqrlb' }],
  ['path', { d: 'm2.305 15.53.923-.382', key: 'yfp9st' }],
  ['path', { d: 'm3.228 12.852-.924-.383', key: 'bckynb' }],
  [
    'path',
    {
      d: 'M4.677 21.5a2 2 0 0 0 1.313.5H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2.5',
      key: '1yo3oz',
    },
  ],
  ['path', { d: 'm4.852 11.228-.383-.923', key: '1j88i9' }],
  ['path', { d: 'm4.852 16.772-.383.924', key: 'sag1dv' }],
  ['path', { d: 'm7.148 11.228.383-.923', key: 'rj39hk' }],
  ['path', { d: 'm7.53 17.696-.382-.924', key: '1uu5cs' }],
  ['path', { d: 'm8.772 12.852.923-.383', key: '13811l' }],
  ['path', { d: 'm8.772 15.148.923.383', key: 'z1a5l0' }],
  ['circle', { cx: '6', cy: '14', r: '3', key: 'a1xfv6' }],
]);

export default FileCog;
